import { useCallback } from 'react';
import validator from '../../components/FieldValidator.jsx';
import EmailAndPhoneValidator from '../../components/EmailAndPhoneValidator.jsx';
import AuthService from '../../services/AuthService.js';

export function useLoginEmailVerificationFlowLogic(state, updateState) {
  const onAddEmail = useCallback((e) => {
    let value = e.value;
    if (e.prop === 'email') {
      value = validator.blockSpaceSymbol(e.value);
    }

    updateState({
      email: value,
      emailError: "",
      birthDateError: "",
      error: false
    });
  }, [updateState]);

  const onBirthDateChange = useCallback((value) => {
    updateState({
      birthDate: value,
      emailError: "",
      birthDateError: "",
      error: false
    });
  }, [updateState]);

  const isEmailValid = useCallback((email, birthDate, businessLogin) => {
    const isEmailStructureValid = EmailAndPhoneValidator.IsEmailStructureValid(email);
    const isBirthDateValid = !!birthDate || businessLogin;

    if (!isEmailStructureValid || !isBirthDateValid) {
      updateState({
        error: true,
        emailError: !isEmailStructureValid ? "empty_email_error_message" : "",
        birthDateError: !isBirthDateValid ? "enter_email_invalid_birth_date_error" : ""
      });
      return false;
    }

    return true;
  }, [updateState]);

  const addEmail = useCallback(async () => {
    const { email, birthDate, businessLogin } = state;
    
    if (!isEmailValid(email, birthDate, businessLogin)) {
      return;
    }

    try {
      const result = businessLogin 
        ? await AuthService.setEmailB2B(email)
        : await AuthService.setEmailB2C(email, birthDate);
      
      const response = result.response.data;

      if (response.success) {
        updateState({ showEmailSent: true, showEnterEmail: false });
        return;
      } else if (response.error === "verification_resend_limit_reached" || response.error === "rate_limit_reached") {
        updateState({ emailError: "missing_email_rate_limit_error" });
        return;
      }

      updateState({
        error: true,
        birthDateError: response.error
      });
    } catch (error) {
      console.error('Add email error:', error);
      updateState({
        error: true,
        emailError: "add_email_network_error"
      });
    }
  }, [state, isEmailValid, updateState]);

  return {
    onAddEmail,
    onBirthDateChange,
    addEmail
  };
}